<template>
  <div class="tree-item" v-if="treeNode">
    <span @click="toggleExpanded()" class="icon" v-if="treeNode && treeNode.children && treeNode.children.length">
      <van-icon name="arrow" v-if="!expanded" @click="expand"/>
      <van-icon name="arrow-down" v-else @click="expand"/>
    </span>
    <span v-else class="icon"></span>
    <span @click="toggleExpanded(treeNode)" class="content">{{ treeNode.dictName }} </span>
    <span v-if="treeNode.checked" class="checkStyle">✔</span>
    <div class="children" v-show="expanded">
      <TreeItem v-for="childNode in treeNode.children" :key="childNode.id" :tree-node="childNode"
                @checkItem="handleChange" @select="toggleExpanded"></TreeItem>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeItem',
  props: {
    // 每一项的节点数据
    treeNode: {
      type: Object,
    }
  },
  data() {
    return {
      // 是否展开
      expanded: false,
    };
  },
  methods: {
    expand(e) {
      this.expanded = !this.expanded;
    },
    toggleExpanded(treeNode) {
      // console.log(treeNode)
      this.$emit('select', treeNode)

    },
    handleChange(item) {
      console.log('handleChange', item, "treeNode", this.treeNode);
      this.setChecked(item, item.checked);
      this.$emit('checkItem', item)
    },
    // 递归 当父集选中或者取消 联动子集
    setChecked(node, checked) {
      node.checked = checked;
      if (node.children && node.children.length > 0) {
        for (let child of node.children) {
          this.setChecked(child, checked);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tree-item {
  position: relative;
  font-size: 14px;
  line-height: 50px;

  .check-item {
    position: absolute;
    top: 10px;
    right: 4px;
    z-index: 111;
    cursor: pointer;
  }

  .icon {
    width: 16px;
    display: inline-block;
    margin-right: 4px;
    line-height: 50px;
    cursor: pointer;
  }

  .content {
    font-size: 16px;
    color: #464A4C;
    letter-spacing: 0;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80%;
    line-height: 50px;
    display: inline-flex;
  }

  .icon-wenjianjia {
    color: #ccc;
    margin-right: 6px;
  }

  .children {
    margin-left: 20px;
  }

  .checkStyle {
    position: absolute;
    right: 4px;
    color: #208FFF;
    font-size: 18px;
    height: 100%;
    line-height: 50px;
  }

  input[type="checkbox"] {
    /* 未选中时的样式 */
    appearance: none;
    border: 1px solid transparent;
    width: 14px;
    height: 14px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    background-color: #eee;
  }

  /* 选中时的样式 */
  input[type="checkbox"]:checked {
    background-color: #eee;
    border: 1px solid #eee;
  }

  /* ✔图标 */
  input[type="checkbox"]:checked:after {
    content: "✔";
    position: absolute;
    left: 1px;
    top: -10px;
    font-size: 12px;
    color: #333;
  }

  .triangle {
    position: relative;
    //top: -4px;
    transition: 0.08s;
  }

  .triangle_up {
    display: inline-block;
    margin: 0px;
    width: 0px;
    height: 0px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #ccc;
  }

  .triangle_down {
    display: inline-block;
    margin: 0px;
    width: 0px;
    height: 0px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #ccc;
  }
}

</style>
